module.exports = __webpack_public_path__ + "static/img/3_fun.4170310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/3_fun.jpg
// module id = R5QT
// module chunks = 0